var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "136",
        viewBox: "0 0 178 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.151 136.001V0H0V136.001H177.151Z", fill: "#4DF4FF" },
      }),
      _c("path", {
        attrs: {
          d: "M19.914 47.3186L64.7622 8.56652C77.9811 -2.85551 99.4126 -2.85551 112.631 8.56652L157.479 47.3186C170.698 58.7406 170.698 77.2592 157.479 88.6814L112.631 127.433C99.4126 138.855 77.9811 138.855 64.7622 127.433L19.914 88.6814C6.69534 77.2592 6.69534 58.7406 19.914 47.3186Z",
          fill: "#38CDFD",
        },
      }),
      _c("path", {
        attrs: {
          d: "M72.0867 51.7879C81.5352 42.7374 96.8544 42.7374 106.303 51.7879C115.751 60.8391 115.752 75.5132 106.303 84.5639C96.8544 93.6148 81.5354 93.6148 72.0867 84.5639C62.6378 75.5132 62.6378 60.8391 72.0867 51.7879Z",
          fill: "#4DF4FF",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }